import React from 'react';

const LoadingSpinner: React.FC = () => (
  <div className="offer-loading-indicator">
    <div className="offer-spinner"></div>
  </div>
);

export default LoadingSpinner;
